import React, { useMemo } from 'react';
import {
  activityColor,
  activityDateText,
  activitySummaryForItems,
} from '../utils/activity';

const SAMPLE_DATES = [
  { label: '≤ 30 dni', days: 15 },
  { label: '1–3 mies.', days: 60 },
  { label: '3–6 mies.', days: 135 },
  { label: '6–12 mies.', days: 270 },
];

function sampleDate(days) {
  return new Date(Date.now() - days * 86400000).toISOString();
}

export default function ActivityLegend({ items = [], scope = 'commune' }) {
  const summary = useMemo(() => activitySummaryForItems(items, scope), [items, scope]);
  return (
    <div className="prospecting-competition-legend prospecting-activity-legend" aria-label="Legenda aktywności handlowej">
      <div className="prospecting-competition-legend-head">
        <strong>Aktywność handlowa</strong>
        <span>{summary.active_count} kontaktów ≤ 12 mies.</span>
      </div>
      <div className="prospecting-activity-gradient">
        {SAMPLE_DATES.map((sample) => (
          <div key={sample.label} className="prospecting-activity-legend-step">
            <i style={{ backgroundColor: activityColor(sampleDate(sample.days)) }} aria-hidden="true" />
            <span>{sample.label}</span>
          </div>
        ))}
        <div className="prospecting-activity-legend-step is-empty">
          <i style={{ backgroundColor: activityColor(null) }} aria-hidden="true" />
          <span>&gt; 12 mies. / brak</span>
        </div>
      </div>
      {summary.latest_activity_at ? <small>Najświeższa: {activityDateText(summary.latest_activity_at)}</small> : null}
    </div>
  );
}
